import type { ReactNode } from 'react';

interface WorkspaceViewFrameProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const WorkspaceViewFrame = ({
  eyebrow = 'Workspace',
  title,
  description,
  actions,
  children
}: WorkspaceViewFrameProps) => (
  <section className="workspace-view-frame" aria-labelledby={`${title.toLowerCase().replace(/\s+/g, '-')}-title`}>
    <header className="workspace-view-header">
      <div className="workspace-view-heading">
        <span className="workspace-view-eyebrow">{eyebrow}</span>
        <h1 id={`${title.toLowerCase().replace(/\s+/g, '-')}-title`}>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="workspace-view-actions">{actions}</div>}
    </header>
    <div className="workspace-view-body">{children}</div>
  </section>
);
